import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'

export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      id:'', //1委办局2街道
      data:[],
    }

    
  }
  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      id:parameter.id,
    },() => {
      this.getList(parameter.id)
    })    
  }

  getList = (id) => {
    httpRequest({
      url: API.organization_list,
      type: 'get',
      data: {
        id:id
      }
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }
  // 点击跳转
  handle_jump = (data) => {
    let children = data.children
    sessionStorage.setItem("organization",encodeURIComponent(JSON.stringify(children)));
    if(data.children && data.children.length > 0){
      this.props.history.push(`/organization/organization_list`);
    } else {
      this.props.history.push('/organization/organization_detail')
    }
  }

  render() {
    const {data} = this.state
    return (
      <div className='organization_container'>
        <div className="content">
        {data.map((item,index) => {
          return <div className='moduleItem' key={index} onClick={this.handle_jump.bind(this,item)}>
                    <div className="logoBox">
                      <img src={item.icon} alt=""/>
                    </div>
                    <div className="name">{item.name}</div>
                </div>
        })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Organization/index.js